/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import H1 from 'components/deprecated/legacyElements/H1';
// eslint-disable-next-line no-unused-vars
import styles from './styles.module.scss';

const TrustPilot = () => (
  <section className="inset">
    <H1 inset>Why companies love SquareFoot</H1>
    <div className="tp-body">
      {/* Widget Loader */}
      <div
        id="tp-widget-loader"
        className="tp-widget-loader tp-rebrand-stars tp-rebrand-stars--5 tp-widget-loader--loaded"
      />
      <div id="tp-widget-wrapper" className="tp-widget-wrapper visible">
        <div id="wrapper-left" className="wrapper-left">
          {/* Human Score */}
          <div className="tp-widget-humanscore">
            <a id="trust-score" target="_blank">
              Excellent
            </a>
          </div>
          {/* Stars */}
          <div className="tp-widget-stars">
            <a id="tp-widget-stars" target="_blank">
              <div className="tp-stars tp-stars--5">
                <div
                  style={{
                    position: 'relative',
                    height: 0,
                    width: '100%',
                    padding: 0,
                    paddingBottom: '18.326693227091635%',
                  }}
                >
                  <img
                    loading="lazy"
                    alt="5 star review"
                    src={require('./5-stars.svg')}
                  />
                </div>
              </div>
            </a>
          </div>
          {/* Business Info */}
          <div className="tp-widget-businessinfo">
            <a id="translations-basedon" target="_blank">
              Based on&nbsp;
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.trustpilot.com/review/squarefoot.com"
            >
              <strong className="bold-underline">89 reviews</strong>
            </a>
          </div>
          {/* Logo */}
          <div id="tp-widget-logo" className="tp-widget-logo">
            <a
              id="profileLink"
              target="_blank"
              rel="noreferrer"
              href="https://www.trustpilot.com/review/squarefoot.com"
            >
              <div
                style={{
                  position: 'relative',
                  height: 0,
                  width: '100%',
                  padding: 0,
                  paddingBottom: '24.6031746031746%',
                }}
              >
                <img
                  loading="lazy"
                  alt="trustpilot logo"
                  src={require('./trustpilot-logo.svg')}
                />
              </div>
            </a>
          </div>
        </div>
        <div id="wrapper-right" className="wrapper-right">
          <div
            id="tp-widget-reviews-wrapper"
            className="tp-widget-reviews-wrapper"
          >
            <div
              id="tp-widget-reviews"
              className="tp-widget-reviews"
              style={{
                userSelect: 'none',
                transitionTimingFunction: 'ease',
                transform: 'translateX(0px)',
                transitionDuration: '0s',
              }}
            >
              <div className="tp-widget-review" style={{ width: '254.75px' }}>
                <a href="https://www.trustpilot.com/review/squarefoot.com#5f03c7083f06f20a94da75be">
                  <div className="tp-widget-stars">
                    <div>
                      <div className="tp-stars tp-stars--5">
                        <div
                          style={{
                            position: 'relative',
                            height: 0,
                            width: '100%',
                            padding: 0,
                            paddingBottom: '18.326693227091635%',
                          }}
                        >
                          <img
                            loading="lazy"
                            alt="5 star review"
                            src={require('./5-stars.svg')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="date secondary-text">July 7</div>
                  <div className="header">
                    Helpful support in navigating NYC market
                  </div>
                  <div className="text">
                    Helpful support in navigating NYC market
                  </div>
                  <div className="name secondary-text">Sam Stein</div>
                </a>
              </div>
              <div className="tp-widget-review" style={{ width: '254.75px' }}>
                <a href="https://www.trustpilot.com/review/squarefoot.com#5ecea5b325e5d209b8f62227">
                  <div className="tp-widget-stars">
                    <div>
                      <div className="tp-stars tp-stars--5">
                        <div
                          style={{
                            position: 'relative',
                            height: 0,
                            width: '100%',
                            padding: 0,
                            paddingBottom: '18.326693227091635%',
                          }}
                        >
                          <img
                            loading="lazy"
                            alt="5 star review"
                            src={require('./5-stars.svg')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="date secondary-text">May 27</div>
                  <div className="header">
                    Really helpful team -- would recommend
                  </div>
                  <div className="text">
                    Really helpful team -- would recommend
                  </div>
                  <div className="name secondary-text">Drew</div>
                </a>
              </div>
              <div className="tp-widget-review" style={{ width: '254.75px' }}>
                <a href="https://www.trustpilot.com/review/squarefoot.com#5e6ba2b43c93ae0964637100">
                  <div className="tp-widget-stars">
                    <div>
                      <div className="tp-stars tp-stars--5">
                        <div
                          style={{
                            position: 'relative',
                            height: 0,
                            width: '100%',
                            padding: 0,
                            paddingBottom: '18.326693227091635%',
                          }}
                        >
                          <img
                            loading="lazy"
                            alt="5 star review"
                            src={require('./5-stars.svg')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="date secondary-text">March 13</div>
                  <div className="header">Making NYC easy</div>
                  <div className="text">
                    Searching for new office space in NYC is daunting - there is
                    a ton of unknowns o...
                  </div>
                  <div className="name secondary-text">Bobby B.</div>
                </a>
              </div>
              <div className="tp-widget-review" style={{ width: '254.75px' }}>
                <a href="https://www.trustpilot.com/review/squarefoot.com#5e6b9b023c93ae091807440d">
                  <div className="tp-widget-stars">
                    <div>
                      <div className="tp-stars tp-stars--5">
                        <div
                          style={{
                            position: 'relative',
                            height: 0,
                            width: '100%',
                            padding: 0,
                            paddingBottom: '18.326693227091635%',
                          }}
                        >
                          <img
                            loading="lazy"
                            alt="5 star review"
                            src={require('./5-stars.svg')}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="date secondary-text">March 13</div>
                  <div className="header">
                    David really educated us on how the…
                  </div>
                  <div className="text">
                    David really educated us on how the commercial office space
                    rental market works...
                  </div>
                  <div className="name secondary-text">Sheila Doyle</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Error Fallback */}
    </div>
  </section>
);

export default TrustPilot;
